
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexcBNrJ84vnkhBLYEUaFTedETNBmPVwIgxee9LZiILRnoMeta } from "/usr/local/app/apps/beliamo.cz/app/pages/index.vue?macro=true";
import { default as searchD5F6QQ50gelrg5pnYRZAIQesULJNen1neRPXJ3zEu9AMeta } from "/usr/local/app/apps/beliamo.cz/app/pages/search.vue?macro=true";
import { default as _91slug_93mjZ5NAym97aJc4mCFu84NsRSNSxRgWUUpOzaWQCG6M8Meta } from "/usr/local/app/apps/beliamo.cz/app/pages/pages/[slug].vue?macro=true";
import { default as indexv8HFcudz19xLd15F7Ug7FRaGt3Ptu4eN25JQVY3_k_QMeta } from "/usr/local/app/apps/beliamo.cz/app/pages/checkout/index.vue?macro=true";
import { default as _91slug_93nr2Qo1Z_zNTK0H_WlDJ4GGSPSJiEYUzPTxkKEW_zR8cMeta } from "/usr/local/app/apps/beliamo.cz/app/pages/stores/[id]/[slug].vue?macro=true";
import { default as _91_91slug_93_93NNat36Bdrmx3nGbP0xWemkiev3ZXbUDzoSBQoM9tnjkMeta } from "/usr/local/app/apps/beliamo.cz/app/pages/products/[id]/[[slug]].vue?macro=true";
import { default as best_45sellers1Oe6KePMZRS2hdNrt_Dn202hutAKWlcfIvv0o3GQ1S4Meta } from "/usr/local/app/apps/beliamo.cz/app/pages/collections/best-sellers.vue?macro=true";
import { default as new_45arrivalsO_7skR6heFRguTu9VAXnGSpTYxp_WPM7AKU64REys8cMeta } from "/usr/local/app/apps/beliamo.cz/app/pages/collections/new-arrivals.vue?macro=true";
import { default as _91_91slug_93_93DcihHd_rPkdzFuMZqf6ZcDipGILxdM3CWro0enfd0ekMeta } from "/usr/local/app/apps/beliamo.cz/app/pages/collections/[id]/[[slug]].vue?macro=true";
import { default as _91code_93SnWCYQQqgsX7yPgpHqXEExPvQnb_u4wb89twci5LN8gMeta } from "/usr/local/app/apps/beliamo.cz/app/pages/checkout/confirmation/[code].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/index.vue")
  },
  {
    name: "index___cs",
    path: "/cs",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/index.vue")
  },
  {
    name: "search___cs",
    path: "/cs/search",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/search.vue")
  },
  {
    name: "pages-slug___cs",
    path: "/cs/pages/:slug()",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/pages/[slug].vue")
  },
  {
    name: "checkout___cs",
    path: "/cs/checkout",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/checkout/index.vue")
  },
  {
    name: "stores-id-slug___cs",
    path: "/cs/stores/:id()/:slug()",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/stores/[id]/[slug].vue")
  },
  {
    name: "products-id-slug___cs",
    path: "/cs/products/:id()/:slug?",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/products/[id]/[[slug]].vue")
  },
  {
    name: "collections-best-sellers___cs",
    path: "/cs/collections/best-sellers",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/collections/best-sellers.vue")
  },
  {
    name: "collections-new-arrivals___cs",
    path: "/cs/collections/new-arrivals",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/collections/new-arrivals.vue")
  },
  {
    name: "collections-id-slug___cs",
    path: "/cs/collections/:id()/:slug?",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/collections/[id]/[[slug]].vue")
  },
  {
    name: "checkout-confirmation-code___cs",
    path: "/cs/checkout/confirmation/:code()",
    component: () => import("/usr/local/app/apps/beliamo.cz/app/pages/checkout/confirmation/[code].vue")
  }
]